"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBDocFrontPositive = function SvgBDocFrontPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M141.506 83.892a2.107 2.107 0 01-2.107-2.107V9.245a5.036 5.036 0 00-5.03-5.03H9.245a5.036 5.036 0 00-5.03 5.03v2.809a2.107 2.107 0 01-4.214 0v-2.81A9.251 9.251 0 019.244 0H134.37a9.251 9.251 0 019.244 9.244v72.541a2.107 2.107 0 01-2.108 2.107z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M134.37 103.912H9.244A9.251 9.251 0 010 94.668V22.085a2.107 2.107 0 114.215 0v72.583a5.036 5.036 0 005.03 5.03H134.37a5.036 5.036 0 005.029-5.03v-2.81a2.107 2.107 0 114.215 0v2.81a9.251 9.251 0 01-9.244 9.244z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M61.815 70.693H25.21a2.107 2.107 0 01-2.108-2.107c.09-9.706 8.016-17.51 17.723-17.448A18.067 18.067 0 0153.47 56.23a2.107 2.107 0 01-2.937 3.02 13.887 13.887 0 00-9.707-3.898A13.452 13.452 0 0027.479 66.48h32.228V20.905H24.171V51.98a2.107 2.107 0 11-4.215 0V18.797c0-1.164.944-2.107 2.108-2.107h39.75c1.164 0 2.108.943 2.108 2.107v49.79a2.107 2.107 0 01-2.107 2.106z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M98.377 87.306H45.25a2.107 2.107 0 110-4.214h53.126a2.107 2.107 0 010 4.214z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M118.312 20.905h-33.17a2.107 2.107 0 010-4.215h33.17a2.107 2.107 0 010 4.215z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M118.312 37.496h-33.17a2.107 2.107 0 010-4.214h33.17a2.107 2.107 0 010 4.214zM118.312 54.088h-33.17a2.107 2.107 0 010-4.215h33.17a2.107 2.107 0 010 4.215zM118.312 70.693h-33.17a2.107 2.107 0 010-4.214h33.17a2.107 2.107 0 010 4.214z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M41.943 46.445a9.792 9.792 0 01-7.776-3.807 2.115 2.115 0 013.336-2.599 5.62 5.62 0 007.832 1.019 5.556 5.556 0 001.026-7.79 5.62 5.62 0 00-7.84-1.019 5.71 5.71 0 00-1.229 1.307 2.114 2.114 0 01-3.512-2.354 9.673 9.673 0 012.15-2.297 9.834 9.834 0 0115.713 9.027 9.771 9.771 0 01-9.7 8.513z",
    fill: "#285"
  })));
};

var _default = SvgBDocFrontPositive;
exports["default"] = _default;